<template>
  <div class="">
    <div v-if="isShow" class="">
      <div class="bg_white mt12 pt16 boxs2">
        <SectionTitle :title="'出金'" :width="'51'" />
        <div class="pb16" :class="{ is_scroll: isScroll, boxs2: isScroll }">
          <h2 class="page_title small ab ml16 mt20 mr16">残高</h2>
          <div class="amount bdb mt16 ml16 mr16 rm">{{ cashAmount.toLocaleString() }}<span class="yen ab">円</span></div>
        </div>
      </div>

      <div id="js-startScroll" class="bg_white mt12 pt16 pb36 boxs2">
        <h2 class="page_title ab ml16 mr16">口座振込額</h2>
        <div class="input_wrap ml16 mr16 mt32">
          <div class="withdraw_price bdb">
            <input class="input rm" type="number" pattern="\d*" :value="withdrawPrice" :max="cashAmount" @input="changeWithdrawPrice">
          </div>
          <span class="yen ab">円</span>
        </div>
        <div class="with_bonus ml16 mt16 mr16">
          <div class="bonus_label">
            <input class="payment_radio" type="checkbox" :checked="!isBonus">
            <label class="payment_contents bonus_content rb" @click="changeWithdrawBonus(false)">すぐに出金する</label>
          </div>
          <p v-if="!isBonus" class="bonus_text rm">振込事務手数料800円をご負担いただきます。</p>
          <p v-if="!isBonus" class="bonus_text rm">お振り込みは<span class="alert">3</span>営業日ほどかかります。</p>
          <div class="bonus_label mt16" :class="{ disabled: !possibleBonusTransfer }">
            <input class="payment_radio" type="checkbox" :checked="isBonus">
            <label class="payment_contents bonus_content rb" @click="changeWithdrawBonus(true)">ボーナスと一緒に出金</label>
          </div>
          <p class="bonus_text alert rm" v-if="!possibleBonusTransfer">条件を満たしていないのでボーナスと一緒に出金することができません。</p>
          <p v-if="isBonus" class="bonus_date rb c5a">ボーナス振込日： {{ transferDate }}</p>
          <p v-if="isBonus" class="bonus_text rm"><span class="bold">今お手続きすると上記ボーナスと一緒に出金することができます。</span></p>
          <p v-if="isBonus" class="bonus_text rm">ボーナスと一緒に出金すると振込事務手数料が掛かりません。</p>

        </div>

      </div>
      <div class="bg_white mt12 pt16 pb36 boxs2">
        <h2 class="page_title ab ml16 mr16">出金金額</h2>
        <WithdrawDetail :ml="'16'" :isConfirm="false" :large="true" :orderPattern="'input'" />
        <div class="btn_wrap">
          <button class="btn_blue ab bank_btn" @click="confirm()">出金確認画面</button>
          <div class="mt24">
            <router-link class="btn_delete back_btn" :to="{ name: 'WalletWithdrawBankCheck' }">戻る</router-link>
          </div>
          <!-- <router-link class="btn_blue ab bank_btn" :to="{ name: 'WalletWithdrawConfirm', params: {} }">出金確認画面</router-link> -->
        </div>
      </div>
      <ErrorModal v-if="isErrorModal" :errorMessage="errorMessage" @modalClose="modalClose" />
    </div>
    <div v-else class="bg_white pt16 pb16 pl16 pr16 ab">アクセスエラー<br>coNPusアプリから再度開き直してください。</div>
  </div>
</template>

<script>
import Check from '@/model/getToken';
import Wallet from '@/components/api/wallet/wallet';
import SectionTitle from '@/components/common/SectionTitle';
import ErrorModal from '@/components/common/ErrorModal';
import DialogModal from '@/components/common/DialogModal';
import WithdrawDetail from '@/components/wallet/WithdrawDetail';
import { mapGetters } from 'vuex';

export default {
  components: {
    SectionTitle,
    ErrorModal,
    DialogModal,

    WithdrawDetail
  },
  data() {
    return {
      isShow: true,
      possibleBonusTransfer: false,
      transferDate: '',
      isSend: true,
      isErrorModal: false,
      errorMessage: '',
      isScroll: false,
    }
  },
  methods: {
    modalClose() {
      this.isErrorModal = false;
    },
    confirm() {
      this.isSend = true;
      this.errorMessage = '';

      // if(this.withdrawPrice < this.withdrawFee && !this.isBonus) {
      //   this.errorMessage += '申請額が手数料以下です。<br>';
      //   this.isSend = false;
      // }
      if(this.withdrawPrice == null || this.withdrawPrice <= 0) {
        this.errorMessage += '口座振込額を入力してください。<br>';
        this.isSend = false;
      }
      if(this.cashAmount - this.amount < 0) {
        this.errorMessage += '口座振込額が残高を超えています。<br>';
        this.isSend = false;
      }
      if(this.isSend) {
        return this.$router.push({ name: 'WalletWithdrawConfirm' });
      } else {
        this.isErrorModal = true;
      }
    },
    changeWithdrawPrice(e) {
      this.$store.commit('setWithdrawWithdrawPrice', Number(e.target.value));
      this.calcWithdrawAmount();
    },
    changeWithdrawBonus(bool) {
      this.$store.commit('setWithdrawIsBonus', bool);
      this.calcWithdrawAmount();
    },
    calcWithdrawAmount() {
      this.$store.dispatch('calcWithdrawAmount', { withdrawPrice: this.withdrawPrice, withdrawFee: this.isBonus ? 0 : this.withdrawFee });
    },
    async apiGetWithdrawInfo() {
      await Wallet.getWithdrawInfo().then((val) => {
        console.log('getWithdrawInfo');
        console.log(val);
        this.possibleBonusTransfer = val.possibleBonusTransfer;
        this.transferDate = val.transferDate;
        this.$store.commit('setWithdrawWithdrawFee', val.withdrawFee);
      });
    },
    handleScroll() {
      const StartScroll = document.getElementById('js-startScroll');
      if(StartScroll) {
        const ClientRect = StartScroll.getBoundingClientRect();
        const scrollY = window.scrollY;
        if(ClientRect.top < scrollY) {
          this.isScroll = true;
        } else {
          this.isScroll = false;
        }
      }

    },
  },
  computed: mapGetters(['totalAmount', 'cashAmount', 'withdrawFee', 'withdrawPrice', 'isBonus', 'amount']),
  async created() {
    let res;
    await Check.checkRequest(this.$route.query.code).then((val) => { res = val; });
    if(res) {
      window.addEventListener("scroll", this.handleScroll);

      await Wallet.getBalance().then((val) => {
        console.log('残高');
        console.log(val);
        this.$store.commit('setWithdrawCashAmount', val.cashAmount);
        this.$store.commit('setWithdrawTotalAmount', val.totalAmount);
      });
      this.apiGetWithdrawInfo();
    } else {
      this.isShow = false;
    }
  },
}
</script>

<style lang="css" scoped>
.is_scroll {
  background-color: #fff;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 5;
}
.page_title.small {
  font-size: 14px;
}
.amount {
  align-items: center;
  display: flex;
  font-size: 18px;
  justify-content: flex-end;
  padding-bottom: 8px;
}
.amount .yen {
  font-size: 14px;
  margin-left: 2px;
}
.bonus_content {
  font-size: 14px;
}

.bonus_label.disabled {
  position: relative;
}
.bonus_label.disabled::before {
  background-color: #aaa;
  content: '';
  height: 100%;
  left: 0;
  opacity: .5;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 4;
}

.bonus_text {
  font-size: 12px;
  margin-top: 5px;
  margin-left: 28px;
}
.alert {
  color: red;
}

.input_wrap {
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
}
.withdraw_price {
  border-width: 2px;
  width: 93.5%;
}
.input {
  border: none;
  color: #4FCCD4;
  font-size: 30px;
  text-align: right;
  width: 100%;
}
.input_wrap .yen {
  margin-left: 8px;
}

.bonus_date {
  font-size: 14px;
  margin-top: 5px;
  margin-left: 28px;
}
/* .bonus {
  margin-top: 29px;
  margin-left: 44px;
  margin-right: 16px;
}
.bonus_list {
  display: flex;
  justify-content: space-between;
  line-height: 1;
  margin-top: 13px;
}

.bonus .bonus_list:last-child {
  border-top: 1px solid  #c9c9c9;
  padding-top: 10px;
}

.bonus_title {
  font-size: 14px;
}
.bonus_price {
  align-items: center;
  display: flex;
  font-size: 16px;
}

.bonus_price .yen {
  font-size: 12px;
  margin-left: 2px;
} */

.bank .bonus_price {
  font-size: 14px;
}

.bank_detail {
  border-top: 1px solid  #c9c9c9;
  border-bottom: 1px solid  #c9c9c9;
}
.detail_title {
  font-size: 12px;
  line-height: 1;
}
.detail_text {
  font-size: 12px;
  margin-top: 5px;
}
.detail_text:not(:first-child) {
  margin-top: 16px;
}

.btn_wrap {
  margin-top: 16%;
}
.bank_btn {
  letter-spacing: 5.5px;
}
.bold {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/wallet/withdraw/Withdraw.vue